import React, { useEffect, useState } from "react";
import { Dimensions, Image, Platform, ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { ModalAlignmentEnum } from "@voltmoney/types";
import LottieView from "lottie-react-native";
import Header from "../../header/Header";
import Typography from "../../typography/Typography";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, TextAlignTokens } from "@voltmoney/schema";
import RenderDigioList from "./RenderDigioList";
import DigioFooter from "./DigioFooter";
import BottomSheet from "../BottomSheet";
import { isMobile, isMobileView } from "../../stack/utils";
import { getScreenType } from "../utils";
import Button from "../../button/Button";
import Icon from "../../icon/Icon";
import { Component as Stack } from "../../stack";
import { Space } from "../../space/Space";
import NeedHelpDC from "../NeedHelpDC";
const RenderDigioCard = ({ backAction, needHelpAction, aadharInitAction, headerTitle, type, stepperProps, triggerAction, lenderInfo, lenderIcon, successCard = false, successTitle, successSubTitle, successButtonTitle, failedCard, failedTitle, failedSubTitle, failedButtonTitle, continueAction, height, failureAction, loading = false, lenderName, shouldShowDocUploadOption, documentUploadAction, showCancelledModal, showAddressMismatchCard, showInProgressCard, counter, isFromJupiter, closeLoaderAction, currentStepId, contactUsDetails, }) => {
    const [showSuccessCard, setShowSuccessCard] = useState(false);
    const [showFailedCard, setShowFailedCard] = useState(false);
    const [isDismissable, setDismissable] = useState(true);
    const [successLottie, setSuccessLottie] = useState("");
    const [showSuccessTitle, setShowSuccessTitle] = useState(successTitle);
    const [addressMismatchCard, setAddressMismatchCard] = useState(showAddressMismatchCard);
    const [inProgressCard, setShowInProgressCard] = useState(false);
    const [hasNavigated, setHasNavigated] = useState(false);
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    useEffect(() => {
        setHasNavigated(false);
    }, []);
    useEffect(() => {
        if (successCard && showInProgressCard === false) {
            const timeoutId = setTimeout(() => {
                if (continueAction && !hasNavigated) {
                    triggerAction({
                        ...continueAction,
                        payload: {
                            currentStepId: currentStepId
                        }
                    });
                }
            }, 3000);
            setShowInProgressCard(false);
            setShowSuccessCard(successCard);
            setShowSuccessTitle(successTitle);
            return () => clearTimeout(timeoutId);
        }
        else if (failedCard && showInProgressCard === false) {
            setShowInProgressCard(false);
            setShowFailedCard(failedCard);
        }
        else if (showAddressMismatchCard) {
            setShowInProgressCard(false);
            setAddressMismatchCard(showAddressMismatchCard);
        }
        else if (inProgressCard) {
            setShowInProgressCard(showInProgressCard);
        }
    }, [successCard, failedCard, showAddressMismatchCard, showInProgressCard, counter, hasNavigated]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch("https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json", {
                    method: "GET",
                });
                const responseData = await response.json();
                setSuccessLottie(responseData);
                setShowSuccessTitle(successTitle);
            }
            catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);
    const modalContentPresenter = () => {
        return (React.createElement(View, { style: styles.modalContainer },
            Platform.OS === 'ios'
                && React.createElement(LottieView, { source: { uri: "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json" }, style: { width: 70, height: 70 }, autoPlay: true, loop: true }),
            Platform.OS !== 'ios'
                && successLottie !== ""
                && React.createElement(LottieView, { source: successLottie, style: { width: 70, height: 'auto' }, autoPlay: true, loop: true }),
            React.createElement(View, { style: { marginTop: 4 } },
                React.createElement(Typography, { label: "KYC done successfully", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: { marginTop: 4 } },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: "You will be redirected to next step in few seconds", fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 32 })),
            React.createElement(View, { nativeID: "bt_borrowerKyc_success", style: { position: 'absolute', bottom: 0, width: '80%', paddingHorizontal: 16, marginBottom: 10 } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.MD, label: "Continue", width: ButtonWidthTypeToken.FULL, onPress: () => {
                        continueAction && triggerAction({
                            ...continueAction,
                            payload: {
                                currentStepId: currentStepId
                            }
                        });
                        if (continueAction)
                            setHasNavigated(true);
                        setShowSuccessCard(false);
                        triggerAction({
                            ...closeLoaderAction
                        });
                    } }))));
    };
    const renderDigioInProgressCard = () => {
        return (React.createElement(View, { style: [
                {
                    justifyContent: 'center',
                    backgroundColor: 'white',
                    borderRadius: 12,
                    padding: 16,
                },
            ] },
            React.createElement(Stack, { justifyContent: StackJustifyContent.center, alignItems: StackAlignItems.center },
                React.createElement(Space, { size: SizeTypeTokens.XXXXL }),
                React.createElement(Icon, { name: IconTokens.Redirecting, size: IconSizeTokens.Size56 }),
                React.createElement(Space, { size: SizeTypeTokens.XL }),
                React.createElement(Text, { style: {
                        textAlignVertical: 'center',
                        textAlign: 'center',
                    } },
                    React.createElement(Typography, { label: "Waiting for response", color: ColorTokens.Grey_Night, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.XL, numberOfLines: 2 })),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                React.createElement(View, { style: {
                        justifyContent: 'center',
                        alignItems: 'center',
                    } },
                    React.createElement(Text, { style: {
                            textAlignVertical: 'center',
                            textAlign: 'center',
                        } },
                        React.createElement(Typography, { label: "Please wait while we process your request", color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, numberOfLines: 2 }))),
                React.createElement(Space, { size: SizeTypeTokens.XXXL }))));
    };
    const renderAddressMismatchCard = () => {
        return (React.createElement(View, { style: styles.userCancelledCard },
            React.createElement(Icon, { name: IconTokens.SystemWarning, size: IconSizeTokens.XXXXXXL }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { label: "Mismatch between address on identity document and current address detected", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24, textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: { borderRadius: 8, backgroundColor: '#FEF4E6', paddingVertical: 8, paddingHorizontal: 16, marginTop: 24 } },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: "For KYC purpose, address on document and current address should be same", fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { nativeID: "bt_borrowerKyc_address_mismatch", style: { marginTop: 24, width: '100%' } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: "Retry DigiLocker KYC", width: ButtonWidthTypeToken.FULL, onPress: () => {
                        setAddressMismatchCard(false);
                        triggerAction({
                            ...closeLoaderAction
                        });
                    } }))));
    };
    const renderUserCancelledContent = () => {
        return (React.createElement(TouchableOpacity, { style: styles.userCancelledCard, activeOpacity: 1 },
            React.createElement(Icon, { name: IconTokens.ErrorIcon, size: IconSizeTokens.Size56 }),
            React.createElement(View, { style: styles.title },
                React.createElement(Typography, { label: failedTitle, fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            failedSubTitle && React.createElement(View, { style: styles.subTitle },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: failedSubTitle, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { nativeID: "bt_borrowerKyc_error", style: styles.errorButton },
                React.createElement(View, null,
                    React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: failedButtonTitle, width: ButtonWidthTypeToken.FULL, onPress: () => {
                            failureAction && triggerAction(failureAction);
                            setShowFailedCard(false);
                            triggerAction({
                                ...closeLoaderAction
                            });
                        } })))));
    };
    const onFooterPressed = () => {
        setShowFailedCard(false);
        setShowSuccessCard(false);
        setShowInProgressCard(Platform.OS === "web");
    };
    const handleCard = async () => {
        await triggerAction({
            ...closeLoaderAction
        });
        if (showFailedCard) {
            setShowFailedCard(false);
            failureAction && await triggerAction(failureAction);
        }
        else if (addressMismatchCard)
            setAddressMismatchCard(false);
        else if (inProgressCard)
            setShowInProgressCard(false);
        else
            setShowSuccessCard(false);
    };
    const modelContentSwitch = () => {
        if (successCard && showCancelledModal) {
            return modalContentPresenter();
        }
        else if (successCard) {
            return modalContentPresenter();
        }
        else if (showCancelledModal) {
            return renderUserCancelledContent();
        }
        else if (failedCard) {
            return renderUserCancelledContent();
        }
        else if (showAddressMismatchCard) {
            return renderAddressMismatchCard();
        }
        else if (inProgressCard) {
            return renderDigioInProgressCard();
        }
        else {
            return null;
        }
    };
    const DynamicTitle = lenderInfo?.lenderAccountId === "Tata" ? "Instantly pull Aadhaar" : "Instantly pull Aadhaar & PAN";
    const calModalHeight = () => {
        let height = 228;
        // height = addressMismatchCard ? 300 : showFailedCard && failedSubTitle?.length > 20 ? isMobileView() ? 260 : 278 : showFailedCard ? 260 : 228
        if (addressMismatchCard) {
            height = 300;
        }
        // else if(showCancelledModal){
        //     height = isMobileView() ? 250 : 228;
        // }
        else if (showFailedCard) {
            if (failedSubTitle?.length > 20) {
                height = isMobileView() ? 284 : 264;
            }
            else if (!failedSubTitle) {
                height = isMobileView() ? 224 : 200;
            }
            else {
                height = 264;
            }
        }
        return height;
    };
    return (React.createElement(View, { style: [styles.container, { height: height, marginHorizontal: -16 }] },
        React.createElement(View, { style: styles.header },
            React.createElement(Header, { id: "bt_borrowerKyc_goBack", needHelpIcon: true, needHelpAction: () => setShowNeedHelp(true), type: type, stepperProps: stepperProps, isBackButton: true, title: headerTitle, onPress: () => {
                    if (backAction) {
                        setShowFailedCard(false);
                        triggerAction(backAction);
                    }
                }, isFromJupiter: isFromJupiter })),
        React.createElement(View, null,
            React.createElement(View, { style: styles.kycText },
                React.createElement(Typography, { label: "Instant KYC via DigiLocker", fontWeight: '600', lineHeight: 24, color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.LG, fontFamily: FontFamilyTokens.Poppins }),
                shouldShowDocUploadOption &&
                    React.createElement(View, null,
                        React.createElement(Typography, { label: "Aadhaar not linked with mobile?", fontWeight: '400', lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter }),
                        React.createElement(TouchableOpacity, { onPress: () => {
                                documentUploadAction &&
                                    triggerAction(documentUploadAction);
                            } },
                            React.createElement(Typography, { label: "Upload KYC documents", fontWeight: '600', lineHeight: 18, color: ColorTokens.Primary_100, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Poppins })))),
            React.createElement(ScrollView, { style: { paddingBottom: 80, height: height - 290 } },
                React.createElement(View, { style: styles.digiLockerContainer },
                    React.createElement(View, { style: styles.image },
                        React.createElement(Image, { resizeMode: 'contain', source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/digio_icon.png" }, style: styles.digioImage })),
                    React.createElement(View, { style: styles.benefitContainer },
                        React.createElement(View, null,
                            React.createElement(Typography, { label: "Digilocker benefits", fontWeight: '500', lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter })),
                        React.createElement(View, null,
                            React.createElement(RenderDigioList, { title: "Fast & secure way to share documents", imageUrl: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/green_shield.png" }),
                            React.createElement(RenderDigioList, { title: DynamicTitle, imageUrl: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Images/acute_icon_lg.png" }),
                            React.createElement(RenderDigioList, { title: "Developed by Government of India", imageUrl: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Images/workload_icon_lg.png" })))))),
        React.createElement(DigioFooter, { triggerAction: triggerAction, aadharInitAction: aadharInitAction, lenderInfo: lenderInfo, lenderIcon: lenderIcon, loading: loading, onFooterPress: () => onFooterPressed(), lenderName: lenderName }),
        (showSuccessCard || showFailedCard || addressMismatchCard || inProgressCard) && (React.createElement(View, { style: { bottom: 0,
                position: 'absolute',
                zIndex: 1 } },
            React.createElement(BottomSheet, { id: "bt_borrowerKyc_cancel", autoAdjustHeight: false, height: calModalHeight(), width: '100%', closeFunction: handleCard, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: showSuccessCard || inProgressCard ? false : isDismissable, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS === "ios" ? Dimensions.get('window').height + 50 : Dimensions.get('window').height + 10 : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, modelContentSwitch()))),
        showNeedHelp && React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails, isFromJupiter: isFromJupiter })));
};
const styles = StyleSheet.create({
    benefitContainer: {
        padding: 16,
    },
    container: {
        marginHorizontal: Platform.OS !== "ios" ? -16 : 0
    },
    header: {
        elevation: 6,
        shadowColor: '#D0D5DD',
        zIndex: 1,
        ...Platform.OS === "ios" && {
            marginTop: 32
        }
    },
    halfCardDescription: { marginTop: 4 },
    digiLockerContainer: {
        marginHorizontal: 16,
        marginTop: 16,
        marginBottom: Platform.OS !== "android" ? 24 : 0,
        borderRadius: 8,
        borderColor: '#E4E7EC',
        borderWidth: 1,
        backgroundColor: ColorTokens.Primary_02,
    },
    digioImage: {
        height: 40,
        width: 120,
    },
    errorButton: {
        width: '100%',
        marginTop: 16,
        // paddingHorizontal: 16,
        // paddingBottom: 8,
        // marginBottom: 4
    },
    title: {
        marginTop: 16,
    },
    subTitle: {
        marginTop: 8,
        padding: 8,
        marginBottom: 8,
        paddingHorizontal: 16,
        borderRadius: 8,
        backgroundColor: '#FEF4E6',
        width: '100%',
        marginHorizontal: 16,
        flexShrink: 1
    },
    stll: {},
    image: {
        paddingLeft: 16,
        paddingTop: 16,
    },
    kycText: {
        marginTop: 24,
        marginHorizontal: 16,
    },
    modal: {
        bottom: 0,
        position: 'absolute',
        zIndex: 1,
    },
    modalContainer: {
        alignItems: "center",
        padding: 16,
        flex: 1
    },
    userCancelledCard: {
        alignItems: "center",
        padding: 16,
        // zIndex: 2,
        ...Platform.OS !== "ios" && {
            flex: 1
        }
    },
});
export default RenderDigioCard;
